import { EnvironmentTypes } from '../types/enums/env-enums';
import RegexCode from '../types/constants/regex';
import {
    enumPaymentMethodStatusTR,
    enumPaymentMethodStatusEN,
    enumBackOfficeUrl,
    enumPaymentMethodStatus,
    enumRefundReasonTypeTR,
    enumRefundReasonTypeEN,
    enumRefundStatusTypeTR,
    enumRefundStatusTypeEN,
} from '../types/enums/status';
import { useSelector } from 'react-redux';

let cachedLcwLogo: string | null = null;

const getUserName = function () {
    let userName = JSON.parse(localStorage.getItem('checkOperator') || '{}')?.username;
    if (userName === undefined || !userName || userName === null) {
        return '';
    } else {
        return userName;
    }
};
//#region Environment Control
const isDevEnv = () => !!(import.meta.env.VITE_ENVIRONMENT === EnvironmentTypes.dev);

const isTestEnv = () => !!(import.meta.env.VITE_ENVIRONMENT === EnvironmentTypes.test);

const isProdEnv = () => !!(import.meta.env.VITE_ENVIRONMENT === EnvironmentTypes.prod);

//#endregion

//#region Empty Null Undefined Control
const objectIsEmpty = (info: object): boolean => {
    if (!isNil(info)) {
        return Object.keys(info).length === 0;
    }
    return false;
};
const GetCurrentCountry = () => {
    const countryStore: any = useSelector((state: any) => state?.country);
    return countryStore.country;
};

const isNil = (value: any) => {
    return isUndefined(value) || isNull(value);
};

const isUndefined = (value: any) => {
    return value === undefined;
};

const isNull = (value: any) => {
    return value === null;
};

//#endregion

//#region Type Check
const getType = (value: any): string => Object.prototype.toString.call(value).slice(8, -1).toLowerCase();

const isArray = (value: any): boolean => Array.isArray(value);

const isObject = (value: any): boolean => typeof value === 'object' && !isArray(value) && getType(value) === 'object';
//#endregion

//#region Parse
const getLang = function () {
    return localStorage.getItem('lan');
};
const formatNumber = (value: number): string => value.toFixed(2).replace('.', ',');

//#endregion

//#region Random
const getBackofficeUrl = (): string => {
    let envType: string = import.meta.env.VITE_ENVIRONMENT!;
    let backofficeUrl: any = '';
    if (envType === 'PROD' && localStorage.getItem('isStoreEmployee') === 'true') {
        backofficeUrl = 'https://store-backoffice.lcwaikiki.com/';
    } else {
        backofficeUrl = Object.entries(enumBackOfficeUrl).find(([key]) => key === envType)?.[1];
    }
    return backofficeUrl;
};
//#endregion

const openInNewTab = (url: string): void => {
    const newWindow = window.open(url, '_blank', 'noopener,noreferrer');
    if (newWindow) newWindow.opener = null;
};

const validateEmail = (value: string): boolean => {
    return RegexCode.emailValidation.test(value.trim().toLowerCase());
};

const getStoreCode = function () {
    return localStorage.getItem('storeCode');
};

const sanitizeHTML = (html: any) => {
    const tempDiv = document.createElement('div');
    tempDiv.innerHTML = html;
    return tempDiv.innerHTML;
};

function isStoreEmployeeForFrontend() {
    const value = localStorage.getItem('storeCode');

    if (value && value.trim().length > 0) {
        return true;
    } else {
        return false;
    }
}

const getRefundReasonName = function (refundReasonId: number) {
    if (getLang() === 'tr-TR') return enumRefundReasonTypeTR[refundReasonId];
    else return enumRefundReasonTypeEN[refundReasonId];
};

const getRefundStatusName = function (refundSatusId: number) {
    if (getLang() === 'tr-TR') return enumRefundStatusTypeTR[refundSatusId];
    else return enumRefundStatusTypeEN[refundSatusId];
};

const getPaymentName = function (paymentMethodId: number, refundWalletType?: number) {
    const isTurkish = getLang() === 'tr-TR';

    // Handle special case for payment method 3 with wallet types
    if (paymentMethodId === 3 && refundWalletType) {
        if (refundWalletType === 1) return isTurkish ? 'LCW Para' : 'LCW Money';
        if (refundWalletType === 2) return isTurkish ? 'İade Para' : 'Return Money';
    }

    // Default payment method names
    return isTurkish ? enumPaymentMethodStatusTR[paymentMethodId] : enumPaymentMethodStatusEN[paymentMethodId];
};

const GetPaymentNameDesc = function (paymentMethodId: number) {
    let methodName = '';
    if (paymentMethodId === enumPaymentMethodStatus.Wire) methodName = 'Havale/EFT';
    else if (paymentMethodId === enumPaymentMethodStatus.CreditCard) methodName = 'Kredi Kartı';
    else if (paymentMethodId === enumPaymentMethodStatus.Wallet) methodName = 'LCW Para';
    //else if (paymentMethodId == (int)PaymentMethodEnum.Wallet && (( WalletPayment)payment).WalletType ==WalletTypeEnum.LcwGiftCardMoney)
    //   methodName = "İade Para";
    else if (paymentMethodId === enumPaymentMethodStatus.Paypal) methodName = 'Paypal';
    else if (paymentMethodId === enumPaymentMethodStatus.CashOnDelivery) methodName = 'Kapıda Ödeme';
    else if (paymentMethodId === enumPaymentMethodStatus.Marketplace) {
        methodName = 'Marketplace Ödemesi';
    } else if (paymentMethodId === enumPaymentMethodStatus.GiftCardWallet) methodName = 'İade Para';
    else if (paymentMethodId === enumPaymentMethodStatus.Loan) methodName = 'Alışveriş Kredisi';
    return methodName;
};

const buildURLFromObject = function (obj: any) {
    console.info(obj);
    const queryParams = Object.entries(obj)
        .map(([key, value]) => {
            if (
                value !== null &&
                value !== undefined &&
                value !== -1 &&
                ((Array.isArray(value) && value.length > 0) || (!Array.isArray(value) && value !== 0 && value !== ''))
            ) {
                // if (key === 'Barcodes' && Array.isArray(value) && value.length > 0) {
                //   const encodedValues = value.map(v => encodeURIComponent(String(v))).join(',');
                //   return `${key}=${encodedValues}`;
                // }
                // else {
                return `${key}=${encodeURIComponent(String(value))}`;
                //}
            }
            return '';
        })
        .filter((param) => param !== '')
        .join('&');

    return `${queryParams}`;
};

const maskName = (fullName: string) => {
    if (fullName && typeof fullName === 'string') {
        const maskedWords = fullName
            .split(' ')
            .map((word) => word.slice(0, 2) + '*'.repeat(Math.max(word.length - 2, 0)))
            .join(' ');
        return maskedWords;
    }

    return fullName;
};

function isValueExistsInJSONArray(jsonArray: any, nodeName: any, targetValue: any) {
    for (let i = 0; i < jsonArray.length; i++) {
        const item = jsonArray[i];

        if (item[nodeName] === targetValue) {
            return true;
        }
    }

    return false;
}
const formatCurrencyByCountry = (amount: number, countryCode: string): string => {
    const localeMap: { [key: string]: string } = {
        TR: 'tr-TR',
        IQ: 'en-US',
        US: 'en-US',
        // Diğer ülkeler için locale mapping buraya eklenmeli
    };
    const locale = localeMap[countryCode] || 'tr-TR';
    return new Intl.NumberFormat(locale, {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
        useGrouping: true,
    }).format(amount);
};
const getCountryCodeFromCountryId = (): string => {
    return JSON.parse(localStorage.getItem('selectedCountry') || '{}')?.countryCode;
};
const formatNumberWithDots = (value: number | string): string => {
    // Gelen değerden noktaları kaldır
    const numericValue = typeof value === 'string' ? Number(value.replace(/\./g, '')) : value;

    // Eğer sayı değilse boş döndür
    if (isNaN(numericValue)) {
        return '';
    }

    // Sayıyı Türkçe formatında noktalı biçimlendir
    return numericValue.toLocaleString('tr-TR', {
        minimumFractionDigits: 0,
        maximumFractionDigits: 0,
    });
};

const getOperatorId = () => {
    return JSON.parse(localStorage.getItem('checkOperator') || '{}')?.operatorId;
};

const loadLogoAsBase64 = async (logoPath: string): Promise<string | null> => {
    try {
        const response = await fetch(logoPath);
        const blob = await response.blob();
        return new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.onloadend = () => {
                const base64String = reader.result as string;
                const base64Data = base64String.split(',')[1];
                resolve(base64Data);
            };
            reader.onerror = reject;
            reader.readAsDataURL(blob);
        });
    } catch (error) {
        console.error('Logo yüklenirken hata oluştu:', error);
        return null;
    }
};

const getLcwLogo = async (): Promise<string | null> => {
    if (cachedLcwLogo) {
        return cachedLcwLogo;
    }

    const logo = await loadLogoAsBase64('/lcw.png');
    if (logo) {
        cachedLcwLogo = logo;
    }
    return logo;
};

const getCustomLogo = async (logoPath: string): Promise<string | null> => {
    return await loadLogoAsBase64(logoPath);
};

const getCountryCode = () => {
    return JSON.parse(localStorage.getItem('selectedCountry') || '{}')?.countryCode;
};

/** Returns numeric countryId from selectedCountry in localStorage; fallback 1. */
const getCountryId = (): number => {
    try {
        const countryId = JSON.parse(localStorage.getItem('selectedCountry') || '{}')?.countryId;
        return countryId != null ? Number(countryId) : 1;
    } catch {
        return 1;
    }
};

const getUserRef = () => {
    return JSON.parse(localStorage.getItem('checkOperator') || '{}')?.userRef;
};

/**
 * Custom query string serializer to replace qs library
 * Serializes params with arrayFormat: 'repeat' (key=value1&key=value2) and skipNulls: true
 * @param params - Object to serialize into query string
 * @returns Serialized query string
 */
const serializeParams = (params: any): string => {
    if (!params || typeof params !== 'object') {
        return '';
    }

    const pairs: string[] = [];

    const addPair = (key: string, value: any) => {
        // Skip null and undefined values (skipNulls: true)
        if (value === null || value === undefined) {
            return;
        }

        const encodedKey = encodeURIComponent(key);

        // Handle arrays with 'repeat' format (key=value1&key=value2)
        if (Array.isArray(value)) {
            if (value.length === 0) {
                return; // Skip empty arrays
            }
            value.forEach((item) => {
                if (item !== null && item !== undefined) {
                    pairs.push(`${encodedKey}=${encodeURIComponent(String(item))}`);
                }
            });
        } else if (typeof value === 'object') {
            // Handle nested objects (flatten them)
            Object.keys(value).forEach((nestedKey) => {
                if (value[nestedKey] !== null && value[nestedKey] !== undefined) {
                    addPair(`${key}[${nestedKey}]`, value[nestedKey]);
                }
            });
        } else {
            // Handle primitive values
            pairs.push(`${encodedKey}=${encodeURIComponent(String(value))}`);
        }
    };

    Object.keys(params).forEach((key) => {
        addPair(key, params[key]);
    });

    return pairs.join('&');
};

const Helper = {
    maskName,
    GetPaymentNameDesc,
    getBackofficeUrl,
    isObject,
    objectIsEmpty,
    isDevEnv,
    isTestEnv,
    isProdEnv,
    isNil,
    isUndefined,
    validateEmail,
    openInNewTab,
    getStoreCode,
    formatNumber,
    isStoreEmployeeForFrontend,
    isValueExistsInJSONArray,
    sanitizeHTML,
    buildURLFromObject,
    getLang,
    getRefundReasonName,
    getRefundStatusName,
    getPaymentName,
    formatNumberWithDots,
    formatCurrencyByCountry,
    getCountryCodeFromCountryId,
    getUserName,
    getOperatorId,
    GetCurrentCountry,
    getLcwLogo,
    getCustomLogo,
    getCountryCode,
    getCountryId,
    getUserRef,
    serializeParams,
};

export default Helper;
